import React, { useState } from 'react';
import axios from 'axios';
import api from "../api/axios";

const DoctorRegisterModal = () => {
  // State to hold all form fields
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    password: '',
    city: '',
    specialty: '',
    gender: '',
    fee: '',          
    qualifications: '', 
    experience: ''    
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // We send formData directly. The backend's registerDoctor function
    // will handle adding the role:'doctor' and creating the DB records.
   axios.post(`${process.env.REACT_APP_API_BASE_URL}/users/register-doctor`, formData)
      .then(res => {
        alert('Registration successful! Please log in.');
        
        // Close modal programmatically
        const closeBtn = document.getElementById('doctorRegisterModalCloseBtn');
        if(closeBtn) closeBtn.click();
        
        // Reset Form
        setFormData({
            name: '', phone: '', email: '', password: '', city: '', specialty: '', gender: '',
            fee: '', qualifications: '', experience: ''
        });
      })
      .catch(err => {
         console.error("Registration Error:", err);
         if (err.response && err.response.data) {
             alert(`Registration Failed: ${err.response.data.message}`);
         } else {
             alert('Error registering. Please try again.');
         }
      });
  };

  return (
    <div className="modal fade" id="doctorRegisterModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          
          <div className="modal-header border-0 pb-0">
            <button type="reset" id="doctorRegisterModalCloseBtn" className="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div className="modal-body pt-0">
            <h5 className="mb-3 fw-bold">Join as a Doctor</h5>
            
            <form onSubmit={handleSubmit}>
                <div className="row">
                    {/* Left Column */}
                    <div className="col-md-6">
                        <div className="mb-3">
                            <input type="text" name="name" className="form-control shadow-none" placeholder="Full Name" required value={formData.name} onChange={handleChange} />
                        </div>
                        <div className="mb-3">
                            <input type="email" name="email" className="form-control shadow-none" placeholder="Email" required value={formData.email} onChange={handleChange} />
                        </div>
                        <div className="mb-3">
                            <input type="text" name="phone" className="form-control shadow-none" placeholder="Phone (0300...)" required value={formData.phone} onChange={handleChange} />
                        </div>
                        <div className="mb-3">
                             <select name="specialty" className="form-select shadow-none" value={formData.specialty} onChange={handleChange} required>
                                <option value="">Select Specialization</option>
                                <option value="Dermatologist">Dermatologist</option>
                                <option value="Gynecologist">Gynecologist</option>
                                <option value="Urologist">Urologist</option>
                                <option value="Gastroenterologist">Gastroenterologist</option>
                                <option value="Neurologist">Neurologist</option>
                                <option value="Dentist">Dentist</option>
                                <option value="Psychiatrist">Psychiatrist</option>
                                <option value="Cardiologist">Cardiologist</option>
                                <option value="Orthopedic Surgeon">Orthopedic Surgeon</option>
                                <option value="Sexologist">Sexologist</option>
                                <option value="Child Specialist">Child Specialist</option>
                                <option value="Pulmonologist">Pulmonologist</option>
                                <option value="Eye Specialist">Eye Specialist</option>
                            </select>
                        </div>
                         <div className="mb-3">
                            <label className="small text-muted">Gender</label><br/>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="gender" value="Male" onChange={handleChange} /> <label>Male</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="gender" value="Female" onChange={handleChange} /> <label>Female</label>
                            </div>
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className="col-md-6">
                        <div className="mb-3">
                            <input type="text" name="city" className="form-control shadow-none" placeholder="City" value={formData.city} onChange={handleChange} />
                        </div>
                        <div className="mb-3">
                            <input type="password" name="password" className="form-control shadow-none" placeholder="Password" required value={formData.password} onChange={handleChange} />
                        </div>
                        
                        {/* Additional Doctor Fields */}
                        <div className="mb-3">
                            <input type="number" name="fee" className="form-control shadow-none" placeholder="Consultation Fee (Rs)" required value={formData.fee} onChange={handleChange} />
                        </div>
                        <div className="mb-3">
                            <input type="text" name="qualifications" className="form-control shadow-none" placeholder="Qualifications (e.g. MBBS)" required value={formData.qualifications} onChange={handleChange} />
                        </div>
                        <div className="mb-3">
                            <input type="text" name="experience" className="form-control shadow-none" placeholder="Experience (e.g. 5 Years)" required value={formData.experience} onChange={handleChange} />
                        </div>
                    </div>
                </div>

                <button type="submit" className="btn w-100 text-black fw-bold btn btn-warning shadow-none mt-3">Sign Up</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorRegisterModal;